var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-text",
        { class: _vm.parentTextClass },
        [
          _c("legacy-title", { staticClass: "mt-3 mb-8 title-branding" }, [
            _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
          ]),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.formIsValid,
                callback: function($$v) {
                  _vm.formIsValid = $$v
                },
                expression: "formIsValid"
              }
            },
            [_vm._t("form")],
            2
          ),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mt-3" })
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("actions")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }